export const FETCH_CUSTOMERS = "customer/FETCH_CUSTOMERS";
export const FETCH_CUSTOMERS_SUCCESS = "customer/FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILURE = "customer/FETCH_CUSTOMERS_FAILURE";
export const RESET_CUSTOMERS = "customer/RESET_CUSTOMERS";

export const FETCH_CUSTOMER = "customer/FETCH_CUSTOMER";
export const FETCH_CUSTOMER_SUCCESS = "customer/FETCH_CUSTOMER_SUCCESS";
export const FETCH_CUSTOMER_FAILURE = "customer/FETCH_CUSTOMER_FAILURE";
export const RESET_CUSTOMER = "customer/RESET_CUSTOMER";

export const FETCH_CUSTOMER_SELLS = "customer/FETCH_CUSTOMER_SELLS";
export const FETCH_CUSTOMER_SELLS_SUCCESS = "customer/FETCH_CUSTOMER_SELLS_SUCCESS";
export const FETCH_CUSTOMER_SELLS_FAILURE = "customer/FETCH_CUSTOMER_SELLS_FAILURE";
export const RESET_CUSTOMER_SELLS = "customer/RESET_CUSTOMER_SELLS";

export const FETCH_CUSTOMERS_BY_PREFIX = "customer/FETCH_CUSTOMERS_BY_PREFIX";
export const FETCH_CUSTOMERS_BY_PREFIX_SUCCESS = "customer/FETCH_CUSTOMERS_BY_PREFIX_SUCCESS";
export const FETCH_CUSTOMERS_BY_PREFIX_FAILURE = "customer/FETCH_CUSTOMERS_BY_PREFIX_FAILURE";
export const RESET_CUSTOMERS_BY_PREFIX = "customer/RESET_CUSTOMERS_BY_PREFIX";

export const BULK_LOAD_CUSTOMERS = "customer/BULK_LOAD_CUSTOMERS";
export const BULK_LOAD_CUSTOMERS_SUCCESS = "customer/BULK_LOAD_CUSTOMERS_SUCCESS";
export const BULK_LOAD_CUSTOMERS_FAILURE = "customer/BULK_LOAD_CUSTOMERS_FAILURE";
export const BULK_LOAD_CUSTOMERS_RESET = "customer/BULK_LOAD_CUSTOMERS_RESET";

export const CUSTOMER_RESET_PASSWORD = 'customer/CUSTOMER_RESET_PASSWORD'
export const CUSTOMER_RESET_PASSWORD_SUCCESS = 'customer/CUSTOMER_RESET_PASSWORD_SUCCESS'
export const CUSTOMER_RESET_PASSWORD_FAILURE = 'customer/CUSTOMER_RESET_PASSWORD_FAILURE'
export const RESET_CUSTOMER_RESET_PASSWORD = 'customer/RESET_CUSTOMER_RESET_PASSWORD'



// WEBPACK FOOTER //
// ./src/store/customer/actionTypes.js